import styled from "styled-components";

const $OptionCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 72px;
  padding: 0 24px;
  gap: 8px;
  border: 1px solid var(--border-card);
  border-radius: 12px;
  box-sizing: border-box;
  cursor: pointer;
  &:hover {
    @media (min-width: 759px) {
      border: 1px solid var(--text-black);
    }
  }
  .title {
    font-weight: 500;
    font-size: 18px;
    color: --var(--text-black);
  }

  .arrow {

  }

  .admin-arrow {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .admin-only {
    font-weight: 400;
    font-size: 15px;
    text-wrap: nowrap;
    color: var(--medium-emphasis-black);
  }
`;

export default $OptionCard;
